module.exports = __webpack_public_path__ + "img/calendarPurple.cddac82.svg";